
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/hosting",
      function () {
        return require("private-next-pages/sub/hosting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/hosting"])
      });
    }
  